
import { TranslationRecord } from '../../types';

export const hero: TranslationRecord = {
  // Hero Section
  heroTitle: 'Ζήστε την Πολυτέλεια στην Καρδιά της Θεσσαλονίκης',
  heroSubtitle: 'Πολυτελής διαμονή με σύγχρονες ανέσεις, προσωπική εξυπηρέτηση και ιδανική κεντρική τοποθεσία',
  exploreMore: 'Εξερευνήστε τις Σουίτες μας',
  bookNow: 'Κράτηση Τώρα',
  guestReviewCount: 'Πάνω από 300 κριτικές επισκεπτών',
  awardedTo: 'Απονεμήθηκε στο',
  travellerReviewAwards: 'Βραβεία Αξιολογήσεων Ταξιδιωτών 2025',
  outOf10: 'από τα 10',
  
  // Page-specific hero translations
  aboutHeroTitle: 'Το Σπίτι σας Μακριά από το Σπίτι',
  aboutHeroSubtitle: 'Ανακαλύψτε την ιστορία πίσω από το Loena Luxury Suites και τη δέσμευσή μας να παρέχουμε εξαιρετική φιλοξενία στην καρδιά της Θεσσαλονίκης.',
  contactHeroTitle: 'Επικοινωνήστε Μαζί μας',
  contactHeroSubtitle: 'Είμαστε εδώ για να κάνουμε τη διαμονή σας στη Θεσσαλονίκη αξέχαστη. Επικοινωνήστε μαζί μας για κρατήσεις, ερωτήσεις ή εξατομικευμένη βοήθεια.',
  reviewsHeroTitle: 'Τι Λένε οι Επισκέπτες μας',
  reviewsHeroSubtitle: 'Διαβάστε αυθεντικές κριτικές από ταξιδιώτες που έχουν βιώσει την άνεση και την πολυτέλεια του Loena Luxury Suites στην καρδιά της Θεσσαλονίκης.',
  
  // Airbnb Badge
  guestFavorite: 'Αγαπημένο επισκεπτών',
  airbnbDescription: 'Ένα από τα πιο αγαπημένα καταλύματα με βάση τις αξιολογήσεις, κριτικές και αξιοπιστία',
  
  // Booking Badge
  bookDirectSave: 'Άμεση Κράτηση -10%',
  
  // Key Features
  primeCityCenter: 'Τέλεια Κεντρική Τοποθεσία',
  modernAmenities: 'Σύγχρονες Ανέσεις',
  personalizedService: 'Προσωπική Εξυπηρέτηση',
  
  // Additional hero translations
  redirectingToBooking: 'Μεταφορά στην κράτηση...',
  openingBookingSystem: 'Άνοιγμα συστήματος κράτησης σε νέα καρτέλα',
  bookingError: 'Σφάλμα Κράτησης',
  enablePopups: 'Παρακαλώ ενεργοποιήστε τα αναδυόμενα παράθυρα και δοκιμάστε ξανά',
  navigating: 'Πλοήγηση',
  scrollingToSuites: 'Μετάβαση στην ενότητα πολυτελών σουιτών',
  redirecting: 'Μεταφορά...',
};
